<template>
  <v-form ref="form">
    <v-sheet class="farm-search-form" width="100%">
      <div :class="{ span2: lgAndDown }">
        <label
          class="secondary--text text-body-2 font-weight-medium"
          for="farm-search-text"
        >
          Código ou nome
        </label>

        <v-text-field
          @input="emitFilters"
          v-model="filters.text"
          id="farm-search-text"
          class="rounded-lg farm-search-form-field"
          color="black"
          prepend-inner-icon="mdi-magnify"
          hide-details
          clearable
          outlined
          dense
        />
      </div>

      <template v-if="lgAndDown">
        <div>
          <label
            class="secondary--text text-body-2 font-weight-medium"
            for="uso-do-solo"
          >
            Tipo de Imóvel
          </label>

          <v-select
            @input="emitFilters"
            v-model="filters.tipo"
            id="uso-do-solo"
            class="rounded-lg farm-search-form-field"
            color="black"
            placeholder="Selecione"
            append-icon="mdi-chevron-down"
            :items="propertyType"
            :menu-props="menuProps"
            hide-details
            clearable
            outlined
            dense
          >
            <template v-slot:item="{ item }">
              <v-sheet
                class="d-flex align-center justify-space-between py-1"
                color="transparent"
                width="100%"
              >
                <span class="text-caption font-weight-regular">
                  {{ item.text }}
                </span>
                <v-icon
                  v-if="filters.states.includes(item.value)"
                  color="primary"
                  right
                  small
                >
                  mdi-check
                </v-icon>
              </v-sheet>
            </template>
          </v-select>
        </div>
      </template>

      <div class="span2 grid-list-2">
        <div>
          <label
            class="secondary--text text-body-2 font-weight-medium"
            for="min-total-area"
          >
            Área total
          </label>

          <v-text-field
            @input="emitFilters"
            @keypress="onlyNumber"
            v-model="filters.minAreaTotal"
            id="min-total-area"
            class="rounded-lg farm-search-form-field"
            color="black"
            placeholder="Min"
            hide-details
            clearable
            outlined
            dense
          />
        </div>

        <div>
          <label
            class="secondary--text text-body-2 font-weight-medium"
            for="max-total-area"
          >
            &nbsp;
          </label>

          <v-text-field
            @input="emitFilters"
            @keypress="onlyNumber"
            v-model="filters.maxAreaTotal"
            id="max-total-area"
            class="rounded-lg farm-search-form-field"
            color="black"
            placeholder="Máx"
            hide-details
            clearable
            outlined
            dense
          />
        </div>
      </div>

      <div class="span2 grid-list-2">
        <div>
          <label
            class="secondary--text text-body-2 font-weight-medium"
            for="min-total-aberta"
          >
            Área aberta
          </label>

          <v-text-field
            @input="emitFilters"
            @keypress="onlyNumber"
            v-model="filters.minAreaAberta"
            id="min-total-aberta"
            class="rounded-lg farm-search-form-field"
            color="black"
            placeholder="Min"
            hide-details
            clearable
            outlined
            dense
          />
        </div>

        <div>
          <label
            class="secondary--text text-body-2 font-weight-medium"
            for="max-total-aberta"
          >
            &nbsp;
          </label>

          <v-text-field
            @input="emitFilters"
            @keypress="onlyNumber"
            v-model="filters.maxAreaAberta"
            id="max-total-aberta"
            class="rounded-lg farm-search-form-field"
            color="black"
            placeholder="Máx"
            hide-details
            clearable
            outlined
            dense
          />
        </div>
      </div>

      <template v-if="!lgAndDown">
        <div>
          <label
            class="secondary--text text-body-2 font-weight-medium"
            for="uso-do-solo"
          >
            Tipo de Imóvel
          </label>

          <v-select
            @input="emitFilters"
            v-model="filters.tipo"
            id="uso-do-solo"
            class="rounded-lg farm-search-form-field"
            color="black"
            placeholder="Selecione"
            append-icon="mdi-chevron-down"
            :items="propertyType"
            :menu-props="menuProps"
            hide-details
            clearable
            outlined
            dense
          >
            <template v-slot:item="{ item }">
              <v-sheet
                class="d-flex align-center justify-space-between py-1"
                color="transparent"
                width="100%"
              >
                <span class="text-caption font-weight-regular">
                  {{ item.text }}
                </span>
                <v-icon
                  v-if="filters.states.includes(item.value)"
                  color="primary"
                  right
                  small
                >
                  mdi-check
                </v-icon>
              </v-sheet>
            </template>
          </v-select>
        </div>
      </template>

      <div>
        <label
          class="secondary--text text-body-2 font-weight-medium"
          for="uso-do-solo"
        >
          Finalidade
        </label>

        <v-select
          @input="emitFilters"
          v-model="filters.cultura"
          id="uso-do-solo"
          class="rounded-lg farm-search-form-field"
          color="black"
          placeholder="Selecione"
          append-icon="mdi-chevron-down"
          :items="purpose"
          :menu-props="menuProps"
          hide-details
          clearable
          outlined
          dense
        >
          <template v-slot:item="{ item }">
            <v-sheet
              class="d-flex align-center justify-space-between py-1"
              color="transparent"
              width="100%"
            >
              <span class="text-caption font-weight-regular">
                {{ item.text }}
              </span>
              <v-icon
                v-if="filters.states.includes(item.value)"
                color="primary"
                right
                small
              >
                mdi-check
              </v-icon>
            </v-sheet>
          </template>
        </v-select>
      </div>

      <div>
        <label
          class="secondary--text text-body-2 font-weight-medium"
          for="estado"
        >
          Localização
        </label>

        <v-autocomplete
          @input="emitFilters"
          @mousedown.prevent
          @keydown.prevent
          v-model="filters.states"
          id="estado"
          class="rounded-lg farm-search-form-field"
          color="black"
          placeholder="Estado"
          append-icon="mdi-chevron-down"
          :items="filteredStates"
          :menu-props="menuProps"
          item-value="value"
          item-text="text"
          hide-details
          clearable
          no-filter
          outlined
          multiple
          dense
        >
          <template v-slot:prepend-item>
            <div class="py-2 px-1 autocomplete-search">
              <v-text-field
                v-model="searchStates"
                class="text-body-2 font-weight-regular"
                no-data-text="Carregando..."
                placeholder="Buscar estado"
                hide-details
                autofocus
                clearable
                dense
                flat
                solo
              />
            </div>
          </template>

          <template v-slot:item="{ item }">
            <v-sheet
              class="d-flex align-center justify-space-between py-1"
              color="transparent"
              width="100%"
            >
              <span class="text-caption font-weight-regular">
                {{ item.text }}
              </span>
              <v-icon
                v-if="filters.states.includes(item.value)"
                color="primary"
                right
                small
              >
                mdi-check
              </v-icon>
            </v-sheet>
          </template>

          <template v-slot:selection="{ item, index }">
            <v-chip
              v-if="index === 0"
              color="rgba(0, 0,0 , 0.08)"
              class="rounded-sm px-2"
              small
            >
              <span class="text-caption font-weight-regular">
                {{ item.text }}
              </span>
            </v-chip>
            <span
              v-if="index === 1"
              class="text-caption font-weight-regular text-no-wrap"
            >
              (+{{ filters.states.length - 1 }})
            </span>
          </template>
        </v-autocomplete>
      </div>

      <div>
        <label
          class="secondary--text text-body-2 font-weight-medium"
          for="cidade"
        >
          &nbsp;
        </label>

        <v-autocomplete
          @input="emitFilters"
          @mousedown.prevent
          @keydown.prevent
          v-model="filters.cities"
          id="cidade"
          class="rounded-lg farm-search-form-field"
          color="black"
          placeholder="Cidade"
          :items="filteredCities"
          no-data-text="Selecione um estado."
          append-icon="mdi-chevron-down"
          :menu-props="menuProps"
          :return-object="false"
          item-disabled="header"
          item-value="value"
          item-text="text"
          hide-details
          clearable
          no-filter
          outlined
          multiple
          dense
        >
          <template v-slot:prepend-item>
            <div
              v-if="filteredCities.length"
              class="py-2 px-1 autocomplete-search"
            >
              <v-text-field
                v-model="searchCities"
                class="text-body-2 font-weight-regular"
                placeholder="Buscar cidade"
                hide-details
                autofocus
                clearable
                dense
                flat
                solo
              />
            </div>
          </template>

          <template v-slot:item="{ item }">
            <v-sheet
              class="d-flex align-center justify-space-between py-1"
              color="transparent"
              width="100%"
            >
              <span class="text-caption font-weight-regular">
                {{ item.text }}
              </span>
              <v-icon
                v-if="filters.cities.includes(item.value)"
                color="primary"
                right
                small
              >
                mdi-check
              </v-icon>
            </v-sheet>
          </template>

          <template v-slot:selection="{ item, index }">
            <v-chip
              v-if="index === 0"
              color="rgba(0, 0,0 , 0.08)"
              class="rounded-sm px-2"
              small
            >
              <span class="text-caption font-weight-regular">
                {{ item.text }}
              </span>
            </v-chip>

            <span
              v-if="index === 1"
              class="text-caption font-weight-regular text-no-wrap"
            >
              (+{{ filters.cities.length - 1 }})
            </span>
          </template>
        </v-autocomplete>
      </div>
    </v-sheet>
  </v-form>
</template>

<script>
import variables from "@/utils/variables";

export default {
  props: {
    states: Array,
    cities: Array,
  },
  data: () => ({
    items: [],
    searchStates: "",
    searchCities: "",
    filters: {
      text: "",
      minAreaTotal: null,
      maxAreaTotal: null,
      minAreaAberta: null,
      maxAreaAberta: null,
      cultura: null,
      tipo: null,
      states: [],
      cities: [],
    },
    menuProps: {
      offsetY: true,
    },
    propertyType: variables.propertyType,
    purpose: variables.purpose,
  }),
  computed: {
    filteredStates() {
      const normalize = (t) =>
        t
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

      const s = normalize(this.searchStates || "");

      const unselected = this.states.filter(
        (i) =>
          !this.filters.states.includes(i.value) &&
          (!s || normalize(i.text).includes(s)) &&
          i.value !== "Corretor",
      );

      const selectedItems = this.states.filter((i) =>
        this.filters.states.includes(i.value),
      );

      return [...selectedItems, ...unselected];
    },
    filteredCities() {
      const normalize = (t) =>
        t
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

      const s = normalize(this.searchCities || "");

      return this.cities.filter(
        (i) => !s || (i.text && normalize(i?.text).includes(s)),
      );
    },
    lgAndDown() {
      return this.$vuetify.breakpoint.lgAndDown;
    },
  },
  methods: {
    onlyNumber(e) {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    },
    emitFilters() {
      this.$emit("change", { ...this.filters });
    },
  },
};
</script>

<style lang="scss" scoped>
.farm-search-form {
  $columns: 9;
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(
    $columns,
    calc((100% / $columns) - (12px / $columns * ($columns - 1)))
  );

  .span2 {
    grid-column: span 2;
  }

  @media screen and (max-width: 1919.9px) {
    $columns: 5;
    row-gap: 6px;
    grid-template-columns: repeat(
      $columns,
      calc((100% / $columns) - (12px / $columns * ($columns - 1)))
    );

    .span2:first-of-type {
      grid-column: span 2;
    }
  }

  @media screen and (max-width: 599.9px) {
    $columns: 3;
    grid-template-columns: repeat(
      $columns,
      calc((100% / $columns) - (12px / $columns * ($columns - 1)))
    );

    > div {
      grid-column: span 3 !important;
    }
  }
}

.farm-search-form-field::v-deep {
  $border-color: #dbdee1;

  background-color: #f3f5f6;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  .v-input__slot {
    padding-right: 8px;
  }

  &.v-text-field--outlined fieldset {
    border-color: $border-color;
  }

  &.v-text-field--outlined.v-input--is-focused fieldset {
    border-color: var(--v-primary-base);
    transition: all 0.1s linear;
  }

  &.v-text-field--outlined.v-input--has-state.error--text fieldset {
    border-color: red;
  }

  .v-input__append-inner {
    padding-left: 0;
  }

  .v-icon {
    color: #9e9e9e;
    font-size: 18px;
  }

  .v-chip {
    margin: 0 4px 0 0;
    max-width: 60%;

    .v-chip__content {
      display: block !important;
      line-height: 24px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  input {
    min-width: 0 !important;
    width: 0;

    &::placeholder {
      color: var(--v-secondary-base);
      font-size: 14px;
    }
  }
}

.grid-list-2 {
  $columns: 2;
  $gap: 6px;

  display: grid;
  gap: $gap;
  grid-template-columns: repeat(
    $columns,
    calc((100% / $columns) - ($gap / $columns * ($columns - 1)))
  );
}
</style>
